import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=2601d370&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=2601d370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2601d370",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2601d370')) {
      api.createRecord('2601d370', component.options)
    } else {
      api.reload('2601d370', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=2601d370&scoped=true&", function () {
      api.rerender('2601d370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commission/comInquiry/detail.vue"
export default component.exports